module.exports = "<app-monthly-charges-tab [reportSection]=\"reportSection\"></app-monthly-charges-tab>\r\n"